import axios from 'axios';
import { Select, Cascader } from 'antd';
import React, { useState, useEffect, useCallback } from 'react';
import { MASTER } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';

const { Option } = Select;

const SelectComponent = (props) => {
  const { column, text, record, data, userProfile, datasource, subdatasource, handleFieldChange, handleKeyPress } = props;

  const [optionList, setOptionList] = useState([]);
  const [conditionList, setConditionList] = useState([]);

  useEffect(() => {
    const siteId = localStorage.get('currentSite');

    // Handle condition list and option list based on props
    if (column.hierarchy) {
      setOptionList(userProfile?.belongsTo?.sites?.[siteId]?.hierarchy || []);
    } else if (Array.isArray(column.table)) {
      setOptionList(column.table);
    }

    if (column?.table?.payload?.conditionList) {
      const conditionList = column.table.payload.conditionList;
      const dataSourceKeys = Object.keys(datasource);
      const subdataSourceKeys = subdatasource ? Object.keys(subdatasource) : [];

      conditionList.forEach((condition, key) => {
        if (condition.referenceKey) {
          if (dataSourceKeys.includes(condition.referenceKey)) {
            conditionList[key].value = datasource[condition.referenceKey];
          } else if (subdataSourceKeys.includes(condition.referenceKey)) {
            conditionList[key].value = subdatasource[condition.referenceKey];
          }
        }
      });

      setConditionList(conditionList);
      getOptionList(column, conditionList);
    } else {
      getOptionList(column);
    }
  }, [column, datasource, subdatasource, userProfile]);

  const getOptionList = useCallback((tableName) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let objectHeader = {};

    if (tableName.hierarchy) {
      setOptionList(userProfile?.belongsTo?.sites?.[siteId]?.hierarchy || []);
    } else if (!tableName.hierarchy) {
      if (Array.isArray(tableName.table)) {
        setOptionList(tableName.table);
        return;
      }

      if (tableName.table?.url) {
        objectHeader = {
          method: tableName.table.method || 'GET',
          url: `${tableName.table.url}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          ...(tableName.table.method === 'POST' && {
            data: {
              ...tableName.table.payload,
              conditionList: conditionList || []
            }
          })
        };
      } else {
        objectHeader = {
          method: 'POST',
          url: `${MASTER.DropDown}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: {
            tableName: tableName.table
          }
        };
      }

      axios(objectHeader)
        .then((response) => {
          if (Array.isArray(response.data)) {
            setOptionList(response.data);
          }
        })
        .catch(() => {
          setOptionList([]);
        });
    }
  }, [userProfile]);

  // const selectedObject = optionList.filter((optionData) => {
  //  return optionData => optionData.value.toString() === text.toString();
  // });

  let filterListed = [];
  if (column?.validation?.duplicate && !column?.validation?.conditionFilter) {
    if (Array.isArray(data)) {
      filterListed = data.map(da => da[column.key]);
    } else if (data && typeof data === 'object') {
      filterListed = Object.keys(data).map(da => data[da][column.key]);
    }
  } else if (column.validation?.conditionFilter && props.equipment) {
    const split = props.equipment.split(/[-]/);
    if (column.validation.conditionFilter[split[0]]) {
      if (Array.isArray(data)) {
        filterListed = data.map(da => da[column.key]);
      } else if (data && typeof data === 'object') {
        filterListed = Object.keys(data).map(da => data[da][column.key]);
      }
    }
  }

  if (column.hierarchy) {
    return (
      <Cascader
        options={optionList}
        showSearch
        value={text || undefined}
        style={{ width: 300 }}
        onChange={(e) => {
          if (e && e.description) {
            handleFieldChange(e, column.key, record.key, e.description);
          } else if (e && e.children) {
            handleFieldChange(e, column.key, record.key, e.children);
          } else {
            handleFieldChange(e, column.key, record.key);
          }
        }}
        onKeyPress={(e) => handleKeyPress(e, record.key)}
        placeholder={column.placeHolder || column.displayName}
        disabled={column.disable || false}
      />
    );
  } else {
    return (
      <Select
        showSearch
        value={
          text||undefined}
        style={{
          width: 300,
          ...(status === 'Completed' ? { opacity: 0.75, pointerEvents: 'none' } : {})
        }}
        onChange={(e) => {
          if (column.autoPopulate) {
            handleFieldChange(e, column.key, record.key, record);
          } else if (column.autoPopulate === 'children') {
            handleFieldChange(e, column.key, record.key, e.children);
          } else if (column.autoNextValue) {
            const selectedData = optionList.find((optionData) => optionData.value === e);
            handleFieldChange(e, column.key, record.key, selectedData);
          } else {
            handleFieldChange(e, column.key, record.key);
          }
        }}
        onKeyPress={(e) => handleKeyPress(e, record.key)}
        placeholder={column.placeHolder || column.displayName}
        disabled={column.disable || false}
        filterOption={(input, option) => {
          return option.props.children.toLowerCase().includes(input.toLowerCase());
        }}
      >
        {optionList
          .filter((col) => {
            if (column?.validation?.duplicate) {
              if (col && col.key && col.value) {
                return !filterListed.includes(col.value);
              }
            }
            return !filterListed.includes(col);
          })
          .map((data, index) => {
            if (column.autoPopulate || column.autoPopulate === 'children') {
              return (
                <Option key={index} value={data.value}>
                  {data.key}
                </Option>
              );
            } else if (column.key === 'InspectionId') {
              return (
                <Option key={index} value={data.Value}>
                  {data.Key}
                </Option>
              );
            } else if (typeof data === 'object' && data !== null) {
              return (
                <Option key={index} value={data.UOM}>
                  {data.UOM}
                </Option>
              );
            } else {
              return (
                <Option key={index} value={data}>
                  {data}
                </Option>
              );
            }
          })}
      </Select>
    );
  }
};

export default SelectComponent;